import { Box, Button, Image, Input, Text, Link } from "@chakra-ui/react";
import { theme } from "../../styles/theme";
import { api } from "../../services/api";
import Logo from "../../assets/images/logo-white-bg.webp";
import logoOrange from "../../assets/images/logo-white-orange.webp";

import { useState } from "react";
import swal  from 'sweetalert';
import { FaHome } from "react-icons/fa";

export function Password() {
  const [userEmail, setUserEmail] = useState("");

  async function handlePasswordResetForUser(e) {
    e.preventDefault();
    try {
      const response = await api.post('/users/password', {
        headers: {
          'Content-Type': 'application/json',
        },
        body: { email: userEmail },
      });

      if (response.data.success) {
        swal({
          title: "Ok",
          text: "Instruções de recueração de senha enviadas para seu email.",
          icon: "success",
        });

      } else {
        swal({
          title: "Oh nooo",
          text: "Algo deu errado, tente novamente!.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error('Error occurred while making the password reset request:', error);
    }
  }

  return (
  <Box
    minH="100vh"
    bg="#f8f8f8"
    display="flex"
    alignItems="center"
    justifyContent="center"
    p={{ base: 4, md: 8 }}
    position="relative"
  >
    <Link
      href="/"
      style={{
        position: "absolute",
        top: "24px",
        right: "24px",
        zIndex: 10,
        textDecoration: "none"
      }}
    >
      <Box
        bg="white"
        p="12px"
        borderRadius="full"
        boxShadow="0 4px 20px rgba(0,0,0,.08)"
      >
        <FaHome color="#004a33" />
      </Box>
    </Link>

    <Box
      maxW="1100px"
      w="100%"
      bg="white"
      borderRadius="24px"
      overflow="hidden"
      boxShadow="0 12px 40px rgba(0,0,0,.08)"
    >
      <Box
        display="flex"
        flexDirection={{ base: "column", lg: "row" }}
      >
        {/* LADO ESQUERDO */}
        <Box
          flex="1"
          bg="linear-gradient(135deg,#004a33,#006b4b)"
          color="white"
          p={{ md: 12 }}
          display={{ base: "none", lg: "flex" }}
          flexDirection="column"
          justifyContent="center"
        >
          <Image
            src={logoOrange}
            maxW="220px"
            mb="10"
            objectFit="contain"
            // filter="brightness(0) invert(1)"
          />

          <Text
            fontSize="48px"
            fontWeight="900"
            lineHeight="1.1"
          >
            Recuperar
            <br />
            Acesso
          </Text>

          <Text
            mt="6"
            opacity=".9"
            fontSize="18px"
            maxW="500px"
          >
            Informe seu e-mail cadastrado e enviaremos
            instruções para redefinir sua senha de forma segura.
          </Text>

          <Box mt="10">
            <Text mb="3">
              ✓ Processo Seguro
            </Text>

            <Text mb="3">
              ✓ Link Exclusivo
            </Text>

            <Text mb="3">
              ✓ Recuperação Imediata
            </Text>

            <Text>
              ✓ Proteção dos Seus Dados
            </Text>
          </Box>
        </Box>

        {/* LADO DIREITO */}
        <Box
          flex="1"
          p={{ base: 6, md: 12 }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Image
            src={Logo}
            maxW="180px"
            mx="auto"
            mb="8"
            display={{ base: "block", lg: "none" }}
          />

          <Text
            fontSize={{ base: "32px", md: "40px" }}
            fontWeight="900"
            color="#004a33"
          >
            Recuperação de Senha
          </Text>

          <Text
            color="gray.500"
            mt="2"
            mb="8"
          >
            Digite o e-mail utilizado no cadastro.
          </Text>

          <Input
            placeholder="Seu e-mail"
            h="56px"
            borderRadius="14px"
            onChange={(e) => setUserEmail(e.target.value)}
            _focus={{
              borderColor: "#fc8f04",
              boxShadow: "0 0 0 1px #fc8f04"
            }}
          />

          <Button
            mt="8"
            h="56px"
            w="100%"
            bg="#fc8f04"
            color="white"
            borderRadius="14px"
            fontWeight="700"
            _hover={{
              bg: "#ea8100"
            }}
            onClick={(e) => handlePasswordResetForUser(e)}
          >
            Enviar Instruções
          </Button>

          <Box
            mt="10"
            pt="6"
            borderTop="1px solid"
            borderColor="gray.100"
          >
            <Text
              fontSize="13px"
              color="gray.500"
              textAlign="center"
            >
              Você receberá um e-mail com um link seguro para
              redefinir sua senha.
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);
}
